<template>
	<div id="Navigation">
		<!-- 左 -->
		<div class="Navig_left">
			<div class="Navig_rijht_top">
				<div class="Navig_rijht_top_L">&nbsp;&nbsp;企业大全</div>
				<router-link tag="div" :to="{path: '/qydq'}" class="Navig_rijht_top_R">查看更多&nbsp;&nbsp;</router-link>
			</div>
			<el-menu class="el-menu-vertical-demo Navig_rijht_bottom tiile_lfet" :collapse="isCollapse">
				<el-submenu style="border-bottom: 1px solid #ececec;" :index="item.id + '' "
					v-for="(item,index) in cbllist" :key="index">
					<template slot="title">
						<span style="width: 100px;height: 40px;line-height: 40px;visibility: visible;"
							slot="title">{{item.name}}</span>
					</template>
					<el-menu-item-group>
						<!-- <span slot="title" style="color: black;">点击分类查看</span> -->
						<div class="Navig_rijht_bottom tiile_lfet">
							<el-submenu style="border-bottom: 1px solid #ececec;" :index="o.id + '' "
								v-for="(o,index) in item.child_1">
								<span slot="title">{{o.name}}</span>
								<div class="Navig_rijht_bottom tiile_lfet" style="width:300px;">
									<router-link tag="div" style="text-align: left;margin-left: 15px;"
										:to="{path: '/qydqdetail', query: {id:item.id,title:item.title}}"
										class="Navig_center_title" v-for="(item,index) in o.child" :key="index">
										{{item.title}}
									</router-link>
								</div>
							</el-submenu>
						</div>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		</div>
		<!-- 中 -->
		<div class="Navig_center">
			<div class="Navig_center_top">
				<el-carousel :interval="5000" indicator-position="none">
					<el-carousel-item v-for="(item,index) in xptjlist" :key="index">
						<img style="width: 100%;height: 100%;" v-lazy="item.picture" class="home_lb"
							@click="openADV(item.advlink)">
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="Navig_center_bottom">
				<div class="Navig_center_bottom_o">
					<el-carousel :interval="5000" indicator-position="none" height="130px">
						<el-carousel-item v-for="(item,index) in 2" :key="index">
							<div @click="openADVs(item)" class="calitems" v-for="(item,index) in xptjlists[index]"
								:key="index">
								<div style="height: 100px;">
									<img v-lazy="item.ewm" style="width: 100%;height: 100%;" alt="">
								</div>
								<div style="height: 30px;font-size: 12px;text-align: center;line-height: 30px;white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;">
									{{item.title}}
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>
		<!-- 右 -->
		<div class="Navig_rijht">
			<div class="Navig_rijht_top">
				<div class="Navig_rijht_top_L">&nbsp;&nbsp;行业资讯</div>
				<router-link class="Navig_rijht_top_R" tag="div" to="/hyzx">查看更多&nbsp;&nbsp;</router-link>
			</div>
			<div class="Navig_rijht_bottom">
				<ul>
					<router-link class="qbes" tag="li" :to="{path: '/hyzxdetail', query: {id:item.id,title:item.title}}"
						v-for="(item,index) in xmggList" :key="index">
						{{item.title}}
					</router-link>
				</ul>
			</div>
		</div>

		<div style="position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgba(0, 0, 0, 0.5);z-index: 9999;" v-show="sfxxzsc">
			<div style="width: 150px;height: 150px;margin: 0 auto;margin-top: 200px;">
				<img :src="ewmoo" style="width: 100%;height: 100%;" alt="">
			</div>
			<div style="width: 600px;height: 50px;margin: 0 auto;margin-top: 100px;">
				<div style="width: 150px;height: 50px;border: 1px solid #FFF;color: #FFF;line-height: 50px;text-align: center;float: left;" @click="djfho">
					点击返回
				</div>
				<div style="width: 150px;height: 50px;border: 1px solid #FFF;color: #FFF;line-height: 50px;text-align: center;float: left;margin-left: 70px;" @click="djfhos">
					进入链接
				</div>
				<div style="width: 150px;height: 50px;border: 1px solid #FFF;color: #FFF;line-height: 50px;text-align: center;float: left;margin-left: 70px;" @click="djfhoss">
					点击申请
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: [],
				xptjlists: [],
				xmggList: [],
				isCollapse: true,
				cbllist: [],
				sfxxzsc:false,
				ewmoo:'',
				link:'',

			}
		},
		methods: {
			openADV(di) {
				console.log(di)
				window.open(di); // row中的数据是表格scope.row  由后台接口返回
			},
			openADVs(item){
				console.log(item)
				this.sfxxzsc = true
				this.ewmoo = item.ewm
				this.link = item.link
			},
			djfho(){
				this.sfxxzsc = false
			},
			djfhos(){
				window.open(this.link); // row中的数据是表格scope.row  由后台接口返回
			},
			djfhoss(){
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if(loginInfo){
					console.log('1')
					this.$router.push('/user')
				}else {
					this.$router.push('/login')
				}
			}
		},
		async mounted() {
			let res = await http.get('api/picture/index?limit=100')
			// this.xptjlist = res.data.data.lunbo
      let ress = await http.get('api/Common/index', {
        model: 'lunbo',
        type: 'content',
        mid: '1',
        fid: '1',
        rows_limit: '16'
      })
      this.xptjlist = ress.data.data.list.data


			let xpList = res.data.data.qyewm
			let newArr = [
				[],
				[],
				[]
			]
			xpList.forEach((item, index) => {
				if (index < 5) {
					newArr[0].push(item)
				} else if (index > 4 && index < 10) {
					newArr[1].push(item)
				} else if (index > 10 && index < 15) {
					newArr[2].push(item)
				}
			})
			this.xptjlists = newArr

			let res2 = await http.get('api/Common/index', {
				model: 'industry',
				type: 'content',
				mid: '7',
				fid: '12',
				rows_limit: '16'
			})
			this.xmggList = res2.data.data.list.data

			let res3 = await http.get('api/qydb/index')
			this.cbllist = res3.data.data
		}
	}
</script>

<style>
	#Navigation {
		width: 100%;
		height: 500px;
		border-radius: 15px;
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	/* 左 */
	.Navig_left {
		width: 23%;
		float: left;
		height: 450px;
		margin-top: 25px;
		border-radius: 10px;
		overflow: hidden;
		margin-left: 1%;
	}

	.Navig_center_title {
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
		text-align: center;
	}

	.Navig_center_title:hover {
		color: coral;
		clear: both;
	}

	/* 中 */
	.Navig_center {
		width: 50%;
		float: left;
		height: 450px;
		margin-top: 25px;
		margin-left: 1%;
	}

	.Navig_center_top {
		width: 100%;
		height: 300px;
	}

	.Navig_center_bottom {
		width: 100%;
		margin-top: 20px;
		height: 130px;
	}

	.Navig_center_bottom_o {
		width: 100%;
		height: 130px;
		box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 24px;
	}

	.calitems {
		width: 19.5%;
		height: 130px;
		margin-left: 0.5%;
		float: left;
	}

	.qbes:hover{
		color: blue;
		text-decoration: underline;
	}

	/* 右 */
	.Navig_rijht {
		width: 23%;
		float: left;
		height: 450px;
		margin-top: 25px;
		margin-left: 1%;
		border-radius: 10px;
		overflow: hidden;
	}

	.Navig_rijht_top {
		width: 100%;
		height: 60px;
		background-color: tomato;
	}

	.Navig_rijht_top_L {
		width: 50%;
		height: 60px;
		float: left;
		line-height: 60px;
		color: #FFF;
		font-size: 24px;
		text-align: left;
		font-weight: 800;
	}

	.Navig_rijht_top_R {
		width: 50%;
		height: 60px;
		float: left;
		line-height: 60px;
		color: #FFF;
		font-size: 14px;
		text-align: right;
	}

	.Navig_rijht_bottom {
		width: 100%;
		height: 390px;
	}

	.tiile_lfet {
		direction: rtl;
		text-align: left;
		overflow: scroll;
	}


	.Navig_rijht_bottom>ul {
		margin: 0;
		padding: 0;
	}

	.Navig_rijht_bottom>ul>li {
		list-style: none;
		width: 95%;
		margin-left: 5%;
		height: 19px;
		margin-top: 5px;
		font-size: 12px;
		line-height: 19px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
	::-webkit-scrollbar {
		width: 4px;
		height: 4px;
		background-color: #FFF;
	}

	/*定义滚动条轨道 内阴影+圆角*/
	::-webkit-scrollbar-track {
		box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		border-radius: 10px;
		background-color: #FFF;
	}

	/*定义滑块 内阴影+圆角*/
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 4px rgba(0, 0, 0, .1);
		-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, .1);
		background-color: #FFF;
	}
</style>
